import { FilterOptionView } from "./filter-option.view";

/**
 * Model filter option carrying its nested Trim options
 */
export class ModelFilterView extends FilterOptionView<string> {
	private _trims: FilterOptionView<string>[];

	constructor(
		name: string,
		count: number,
		value: string,
		trims: FilterOptionView<string>[]
	) {
		super(name, count, value);
		this._trims = trims;
	}

	get trims(): FilterOptionView<string>[] {
		return this._trims;
	}
}

/**
 * Make/Model filter options with hierarchical structure
 */
export class MakeModelFilterView {
	private _models: ModelFilterView[];

	constructor(
		public readonly name: string,
		public readonly count: number,
		models: ModelFilterView[]
	) {
		this._models = models;
	}

	get models(): ModelFilterView[] {
		return this._models;
	}
}
